module.exports = __webpack_public_path__ + "assets/img/nen-iso.cbd9ad6a.png";